import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import './ProfessionalValidation.css';

const ProfessionalValidation = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        profession: '',
        specialty: '',
        institution: '',
        institutionalEmail: '',
        orcid: '',
        licenseNumber: '',
        cvUrl: '',
        licenseDocUrl: '',
        experienceYears: 0,
        researchAreas: '',
        hIndex: '',
        citations: '',
        activeStudies: '',
        website: ''
    });
    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = {
                ...formData,
                researchAreas: formData.researchAreas.split(',').map(s => s.trim())
            };
            await axios.post('/api/users/validate-request', data);
            setMsg('Solicitud enviada con éxito');
            window.location.href = '/profile';
        } catch (err) {
            setMsg('Error al enviar la solicitud');
        }
        setLoading(false);
    };

    return (
        <div className="validation-page">
            <div className="validation-card">
                <div className="val-header">
                    <img src="/logoecseia.png" alt="Logo" className="val-logo" />
                    <h2>Solicitud de Validación Profesional</h2>
                    <p>Completa tu perfil de investigador para acceder a la red avanzada.</p>
                </div>

                {msg && <p className={`msg ${msg.includes('éxito') ? 'success' : 'error'}`}>{msg}</p>}

                <form onSubmit={handleSubmit} className="val-form">
                    <h3 className="section-title">Información Básica</h3>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Profesión / Cargo</label>
                            <input name="profession" value={formData.profession} onChange={handleChange} required className="val-input" placeholder="Ej: Investigador Senior" />
                        </div>
                        <div className="form-group">
                            <label>Especialidad Principal</label>
                            <input name="specialty" value={formData.specialty} onChange={handleChange} required className="val-input" placeholder="Ej: Oncología" />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Institución / Centro de Investigación</label>
                        <input name="institution" value={formData.institution} onChange={handleChange} required className="val-input" placeholder="Ej: NIH, Universidad X" />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Email Institucional</label>
                            <input type="email" name="institutionalEmail" value={formData.institutionalEmail} onChange={handleChange} required className="val-input" placeholder="nombre@institucion.org" />
                        </div>
                        <div className="form-group">
                            <label>ORCID</label>
                            <input name="orcid" value={formData.orcid} onChange={handleChange} placeholder="0000-0000-0000-0000" className="val-input" />
                        </div>
                    </div>

                    <h3 className="section-title">Métricas de Investigador</h3>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Índice H</label>
                            <input type="number" name="hIndex" value={formData.hIndex} onChange={handleChange} className="val-input" />
                        </div>
                        <div className="form-group">
                            <label>Citas Totales</label>
                            <input type="number" name="citations" value={formData.citations} onChange={handleChange} className="val-input" />
                        </div>
                        <div className="form-group">
                            <label>Estudios Activos</label>
                            <input type="number" name="activeStudies" value={formData.activeStudies} onChange={handleChange} className="val-input" />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Áreas de Interés (separadas por coma)</label>
                        <input name="researchAreas" value={formData.researchAreas} onChange={handleChange} placeholder="Inmunoterapia, Genómica, Ensayos Clínicos..." className="val-input" />
                    </div>

                    <div className="form-group">
                        <label>Sitio Web / Laboratorio URL</label>
                        <input name="website" value={formData.website} onChange={handleChange} placeholder="https://..." className="val-input" />
                    </div>

                    <h3 className="section-title">Documentación</h3>
                    <div className="form-group">
                        <label>Número de Licencia / Colegiado</label>
                        <input name="licenseNumber" value={formData.licenseNumber} onChange={handleChange} required className="val-input" />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>URL de CV</label>
                            <input name="cvUrl" value={formData.cvUrl} onChange={handleChange} className="val-input" placeholder="Link a PDF o LinkedIn" />
                        </div>
                        <div className="form-group">
                            <label>URL de Documento de Identidad Profesional</label>
                            <input name="licenseDocUrl" value={formData.licenseDocUrl} onChange={handleChange} className="val-input" />
                        </div>
                    </div>

                    <button type="submit" className="btn-submit-val" disabled={loading}>
                        {loading ? 'Procesando...' : 'Enviar para Verificación'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ProfessionalValidation;
